// Autogenerated by util/sync-labels/sync-labels.ts
// Do not edit this file directly.
// To regenerate this file, start ithriv_landing_service locally on port 8000 and
// run the following command in the root directory of the ithriv_web repository:
// > npm run sync_labels
import {LabelResponse} from '@backend';
import {SensitivityLevel} from '@shared/labels/sensitivity-level';

export enum IdentifierHipaa {
  NA = 'na',
  NONE = 'none',
  ZIP_SHORT = 'zip-short',
  REGION = 'region',
  DATES_YEAR = 'dates-year',
  DATES_SHIFTED = 'dates-shifted',
  DATES_FULL = 'dates-full',
  AGES = 'ages',
  CITY_ZIP = 'city-zip',
  MEDICAL_RECORD_NUM = 'medical-record-num',
  NAMES = 'names',
  ADDRESSES = 'addresses',
  EMAIL_PHONE_FAX = 'email-phone-fax',
  SOCIAL_SECURITY = 'social-security',
  BIOMETRIC_ID = 'biometric-id',
  CERTIFICATE_NUM = 'certificate-num',
  VEHICLE_ID = 'vehicle-id',
  DEVICE_ID = 'device-id',
  OTHER_UNIQUE = 'other-unique',
}

export const IdentifierHipaaLabels = {
  na: 'N/A: Not derived from Medical Records',
  none: 'NONE',
  'zip-short': 'First 3 digits of ZIP and if population <20K ZIP changed to 000',
  region: 'STATE or larger regions',
  'dates-year': 'DATES using only YEAR and NO AGES > 90',
  'dates-shifted': 'Random Date Shifts Applied at Row Level',
  'dates-full': 'DATES with MONTH/DAY/YEAR',
  ages: 'AGES > 90 are reflected in data',
  'city-zip': 'CITY, ZIP, or equivalent GEOCODES',
  'medical-record-num': 'MEDICAL RECORD # or ACCOUNT # or HEALTH PLAN BENEFICIARIES',
  names: 'NAMES, INITIALS, FIRST 3 LETTERS of LAST NAME',
  addresses: 'ADDRESSES and equivalent GEOCODES',
  'email-phone-fax': 'EMAIL or PHONE or FAX #',
  'social-security': 'SOCIAL SECURITY # or last 4 digits',
  'biometric-id': 'BIOMETRIC IDs or FINGER PRINTS or VOICE RECORDINGS or FULL FACE IMAGES',
  'certificate-num': 'CERTIFICATE # or LICENSE #',
  'vehicle-id': 'VEHICLE ID, SN, or Plate #',
  'device-id': 'DEVICE ID or SN or IP address; Web URLs',
  'other-unique': 'OTHER UNIQUE IDENTIFIERS',
} as const;

export type IdentifierHipaaId = keyof typeof IdentifierHipaaLabels;
export type IdentifierHipaaLabel = (typeof IdentifierHipaaLabels)[IdentifierHipaaId];

export const IdentifierHipaaOptions: Record<IdentifierHipaa, LabelResponse> = {
  na: {
    id: IdentifierHipaa.NA,
    text: IdentifierHipaaLabels[IdentifierHipaa.NA],
    sensitivity_level_id: SensitivityLevel.NA,
    display_order: 0,
  },
  none: {
    id: IdentifierHipaa.NONE,
    text: IdentifierHipaaLabels[IdentifierHipaa.NONE],
    sensitivity_level_id: SensitivityLevel.DE_ID,
    display_order: 1,
  },
  'zip-short': {
    id: IdentifierHipaa.ZIP_SHORT,
    text: IdentifierHipaaLabels[IdentifierHipaa.ZIP_SHORT],
    sensitivity_level_id: SensitivityLevel.DE_ID,
    display_order: 2,
  },
  region: {
    id: IdentifierHipaa.REGION,
    text: IdentifierHipaaLabels[IdentifierHipaa.REGION],
    sensitivity_level_id: SensitivityLevel.DE_ID,
    display_order: 3,
  },
  'dates-year': {
    id: IdentifierHipaa.DATES_YEAR,
    text: IdentifierHipaaLabels[IdentifierHipaa.DATES_YEAR],
    sensitivity_level_id: SensitivityLevel.DE_ID,
    display_order: 4,
  },
  'dates-shifted': {
    id: IdentifierHipaa.DATES_SHIFTED,
    text: IdentifierHipaaLabels[IdentifierHipaa.DATES_SHIFTED],
    sensitivity_level_id: SensitivityLevel.DE_ID,
    display_order: 5,
  },
  'dates-full': {
    id: IdentifierHipaa.DATES_FULL,
    text: IdentifierHipaaLabels[IdentifierHipaa.DATES_FULL],
    sensitivity_level_id: SensitivityLevel.LDS,
    display_order: 6,
  },
  ages: {
    id: IdentifierHipaa.AGES,
    text: IdentifierHipaaLabels[IdentifierHipaa.AGES],
    sensitivity_level_id: SensitivityLevel.LDS,
    display_order: 7,
  },
  'city-zip': {
    id: IdentifierHipaa.CITY_ZIP,
    text: IdentifierHipaaLabels[IdentifierHipaa.CITY_ZIP],
    sensitivity_level_id: SensitivityLevel.LDS,
    display_order: 8,
  },
  'medical-record-num': {
    id: IdentifierHipaa.MEDICAL_RECORD_NUM,
    text: IdentifierHipaaLabels[IdentifierHipaa.MEDICAL_RECORD_NUM],
    sensitivity_level_id: SensitivityLevel.HSD,
    display_order: 9,
  },
  names: {
    id: IdentifierHipaa.NAMES,
    text: IdentifierHipaaLabels[IdentifierHipaa.NAMES],
    sensitivity_level_id: SensitivityLevel.HSD,
    display_order: 10,
  },
  addresses: {
    id: IdentifierHipaa.ADDRESSES,
    text: IdentifierHipaaLabels[IdentifierHipaa.ADDRESSES],
    sensitivity_level_id: SensitivityLevel.HSD,
    display_order: 11,
  },
  'email-phone-fax': {
    id: IdentifierHipaa.EMAIL_PHONE_FAX,
    text: IdentifierHipaaLabels[IdentifierHipaa.EMAIL_PHONE_FAX],
    sensitivity_level_id: SensitivityLevel.HSD,
    display_order: 12,
  },
  'social-security': {
    id: IdentifierHipaa.SOCIAL_SECURITY,
    text: IdentifierHipaaLabels[IdentifierHipaa.SOCIAL_SECURITY],
    sensitivity_level_id: SensitivityLevel.HSD,
    display_order: 13,
  },
  'biometric-id': {
    id: IdentifierHipaa.BIOMETRIC_ID,
    text: IdentifierHipaaLabels[IdentifierHipaa.BIOMETRIC_ID],
    sensitivity_level_id: SensitivityLevel.HSD,
    display_order: 14,
  },
  'certificate-num': {
    id: IdentifierHipaa.CERTIFICATE_NUM,
    text: IdentifierHipaaLabels[IdentifierHipaa.CERTIFICATE_NUM],
    sensitivity_level_id: SensitivityLevel.HSD,
    display_order: 15,
  },
  'vehicle-id': {
    id: IdentifierHipaa.VEHICLE_ID,
    text: IdentifierHipaaLabels[IdentifierHipaa.VEHICLE_ID],
    sensitivity_level_id: SensitivityLevel.HSD,
    display_order: 16,
  },
  'device-id': {
    id: IdentifierHipaa.DEVICE_ID,
    text: IdentifierHipaaLabels[IdentifierHipaa.DEVICE_ID],
    sensitivity_level_id: SensitivityLevel.HSD,
    display_order: 17,
  },
  'other-unique': {
    id: IdentifierHipaa.OTHER_UNIQUE,
    text: IdentifierHipaaLabels[IdentifierHipaa.OTHER_UNIQUE],
    sensitivity_level_id: SensitivityLevel.HSD,
    display_order: 18,
  },
} as const;
